module.exports = __webpack_public_path__ + "img/fresh.30838979.svg";